import * as cnames from 'classnames'
import * as React from 'react'

import FullscreenIcon from '../../../components/icons/fullscreen'

import * as styles from './fullscreenButton.module.css'

interface IProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement | HTMLButtonElement> {
  iconClassName?: string
}

const FullscreenButton = ({ onClick, iconClassName, className }: IProps) => {
  return (
    <button
      className={cnames(styles.root, className)}
      onClick={onClick}
      title="Open fullscreen"
    >
      <FullscreenIcon className={iconClassName} />
    </button>
  )
}

export default FullscreenButton
